import { render } from "./ReportGenerator.vue?vue&type=template&id=4e2acafc"
import script from "./ReportGenerator.vue?vue&type=script&lang=js"
export * from "./ReportGenerator.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__